module.exports = __webpack_public_path__ + "static/media/gold-s-20.1ee8535c.png";